var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "html-content-wrapper",
      staticStyle: { height: "500px", overflow: "scroll" }
    },
    [
      _c("iframe", {
        ref: "iframe",
        staticClass: "content-iframe",
        attrs: { frameborder: "0" }
      })
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }